angular.module('zc.projects')

.directive 'campaignPolicyStep', ($q, $translate, CampaignSegment, InterestWidget, Meta) ->
  restrict: 'E'
  scope:
    project: '='
    campaign: '='
    policyForm: '='
    clearanceItemSets: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_policy_step.html'
  link: (scope, element, attrs) ->
    scope.campaign_segments = []
    scope.availableTestingUnits = []
    scope.days_since_last_received_enabled = scope.campaign.days_since_last_received >= 1
    scope.days_since_last_received_conversion_enabled = scope.campaign.days_since_last_received_conversion >= 1

    isSavedInterestWidget = (campaign) ->
      campaign.interest_widget_id >= 1 and
      !campaign.is_coupon_campaign and
      campaign.delivery_type_option and
      campaign.delivery_type_option.id is 'complete_delivery'

    scope.isSavedInterestWidget = isSavedInterestWidget(scope.campaign)

    CampaignSegment.all(scope.campaign.project_id).then (res) ->
      scope.campaign_segments = res
      scope.campaign_segments.unshift {id: null, name: $translate.instant('projectsCampaigns.directives.campaignPolicyStep.unspecified')}

      segment_found = false
      for segment in scope.campaign_segments
        if segment.id is scope.campaign.segment_id
          segment_found = true
          break
      unless segment_found
        scope.campaign.segment = null
        scope.campaign.segment_id = null

      # Finally ignore custom olds except if it's already selected
      scope.campaign_segments = _.chain res
        .filter (d) -> d.segment_type != 'custom_old' || d.id == scope.campaign.segment_id
        .filter (d) -> !d.deprecated
        .sortBy (d) -> -new Date(d.created_at)
        .value()

      findSegment scope.campaign.segment_id

    findSegment = (segment_id) ->
      scope.campaign.segment = _.find scope.campaign_segments,
        id: segment_id

    Meta.getTestingUnits().then (testingUnits) ->
      scope.availableTestingUnits = testingUnits

    scope.$watch 'campaign.segment_id', (segment_id) ->
      findSegment segment_id

    scope.$watch 'campaign.delivery_type_option', (_new, _old, newScope) ->
      InterestWidget.updateCampaignWithInterestWidget newScope.campaign
      .then ->
        scope.isSavedInterestWidget = isSavedInterestWidget(newScope.campaign)
    , true

    scope.setCampaignControlPercentToZero = () ->
      scope.campaign.campaign_control_percent = 0

    scope.toggleDaysSinceLastReceived = () ->
      scope.days_since_last_received_enabled = !scope.days_since_last_received_enabled
      if scope.campaign.days_since_last_received?
        scope.campaign.days_since_last_received = null
      else
        scope.campaign.days_since_last_received = 3

    scope.toggleDaysSinceLastReceivedConversion = () ->
      scope.days_since_last_received_conversion_enabled = !scope.days_since_last_received_conversion_enabled
      if scope.campaign.days_since_last_received_conversion?
        scope.campaign.days_since_last_received_conversion = null
      else
        scope.campaign.days_since_last_received_conversion = 14



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_policy_step.coffee